import {Component, OnInit} from "@angular/core";
import {firstValueFrom} from "rxjs";
import {
    FileAttachment,
    FileAttachmentsV1Service,
    MarketingFiles,
    MarketingFilesV1Service,
    MarketingFileType
} from "../../apis/backend";

@Component({
    selector: 'marketing-files',
    templateUrl: './marketing-files.component.html',
})
export class MarketingFilesComponent implements OnInit {
    
    public marketingFiles: MarketingFiles;
    
    public EditMode = false;

    protected readonly MarketingFileType = MarketingFileType;
    
    constructor(private _fileAttachmentService: FileAttachmentsV1Service,
                private _marketingFilesService: MarketingFilesV1Service) {}
    
    ngOnInit() {
        this._marketingFilesService.getFiles()
            .subscribe(files => {
                this.marketingFiles = files;
            });
    }

    public FileUploader(fileType: MarketingFileType) {
        return (file: File) => {
            return firstValueFrom(this._marketingFilesService.uploadFile(
                fileType,
                file));
        }
    }

    public FileDeleter() {
        return (fileAttachment: FileAttachment) => {
            return firstValueFrom(this._marketingFilesService.deleteFile(
                fileAttachment.FileAttachmentID));
        }
    }
}